/**
 * @graphql agg
 */
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ConfluenceTransactionAccountEndOfTrialQuery: GraphQLTaggedNode = graphql`
	query ConfluenceTransactionAccountEndOfTrialQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					transactionAccount {
						isBillToPresent
						isCurrentUserBillingAdmin
					}
				}
			}
		}
	}
`;
